import { graphql } from "api/cms-website/generated";

export const ClinicsMapFragment = graphql(/* GraphQL */ `
    fragment ClinicsMapFragment on ComponentComponentsClinicsMap {
        id
        clinicsMapTitle: title
        image {
            url
            width
            height
            alternativeText
        }
        noMarginBottom
    }
`);
